import { render, staticRenderFns } from "./TransactionLogAwards.vue?vue&type=template&id=3d486372"
import script from "./TransactionLogAwards.vue?vue&type=script&lang=js"
export * from "./TransactionLogAwards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports